import { Alert, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { usePlanDetailPage } from './hooks/usePlanDetailPage';
import { PlanDetailPageView } from './PlanDetailPageView';

export function PlanDetailPageContainer() {
  const { t } = useTranslation('maintenance');
  const {
    planId,
    plan,
    isLoading,
    planError,
    sectionError,
    taskRows,
    assetRows,
    scheduleRows,
    taskColumns,
    taskExpandable,
    assetColumns,
    scheduleColumns,
    assetsTotal,
    assetsPage,
    assetsPageSize,
    assetsLoading,
    onAssetsPageChange,
    schedulesTotal,
    schedulesPage,
    schedulesPageSize,
    schedulesLoading,
    onSchedulesPageChange,
    onBack,
  } = usePlanDetailPage();

  if (!planId) {
    return <Alert type="error" showIcon title={t('detail.missingPlanId')} />;
  }

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (planError) {
    return (
      <Alert
        type="error"
        showIcon
        title={t('detail.errorLoading')}
        description={planError.message}
      />
    );
  }

  if (!plan) {
    return <Alert type="warning" showIcon title={t('detail.notFound')} />;
  }

  return (
    <PlanDetailPageView
      plan={plan}
      taskRows={taskRows}
      assetRows={assetRows}
      scheduleRows={scheduleRows}
      taskColumns={taskColumns}
      taskExpandable={taskExpandable}
      assetColumns={assetColumns}
      scheduleColumns={scheduleColumns}
      sectionError={sectionError}
      assetsTotal={assetsTotal}
      assetsPage={assetsPage}
      assetsPageSize={assetsPageSize}
      assetsLoading={assetsLoading}
      onAssetsPageChange={onAssetsPageChange}
      schedulesTotal={schedulesTotal}
      schedulesPage={schedulesPage}
      schedulesPageSize={schedulesPageSize}
      schedulesLoading={schedulesLoading}
      onSchedulesPageChange={onSchedulesPageChange}
      onBack={onBack}
    />
  );
}
